export default "__VITE_ASSET__ebade911__"